<template>
  <div>
    <div class="closepass-button">
      <Button
        @click="pushBack"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-plain"
      />
    </div>
    <div v-if="this.isLoading" class="aeroexpress-schedule_skeleton-wrapper">
      <Skeleton
        class="aeroexpress-schedule__skeleton"
        width="290px"
        height="26px"
      />
      <Skeleton
        class="aeroexpress-schedule__skeleton"
        width="320px"
        height="26px"
      />
      <Skeleton
        class="aeroexpress-schedule__skeleton"
        width="340px"
        height="26px"
      />
      <Skeleton
        class="aeroexpress-schedule__skeleton"
        width="180px"
        height="26px"
      />
      <Skeleton
        class="aeroexpress-schedule__skeleton"
        width="345px"
        height="1450px"
      />
    </div>
    <div v-else>
      <p class="choosen-order__aeroexpress-info__title">
        {{
          `Расписание аэроэкспресс
от станции «${this.nameDep}»
до станции «${this.nameArr}»
${getDate(this.time)}`
        }}
      </p>
      <div class="choosen-order__aeroexpress-info__schedule-wrapper">
        <div class="choosen-order__aeroexpress-info__schedule-titles__wrapper">
          <table class="choosen-order__aeroexpress-info__schedule-table">
            <thead>
              <tr>
                <th>
                  <div
                    class="
                      choosen-order__aeroexpress-info__schedule-titles__title-wrapper
                    "
                  >
                    <p
                      class="
                        choosen-order__aeroexpress-info__schedule-titles__title
                      "
                    >
                      {{ this.nameDep }}
                    </p>
                    <p
                      class="
                        choosen-order__aeroexpress-info__schedule-titles__info
                      "
                    >
                      Отправление
                    </p>
                  </div>
                </th>
                <th>
                  <div
                    class="
                      choosen-order__aeroexpress-info__schedule-titles__title-wrapper
                    "
                  >
                    <p
                      class="
                        choosen-order__aeroexpress-info__schedule-titles__title
                      "
                    >
                      {{ this.nameArr }}
                    </p>
                    <p
                      class="
                        choosen-order__aeroexpress-info__schedule-titles__info
                      "
                    >
                      Прибытие
                    </p>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(time, index) in this.newSchedule.Response"
                :key="index"
              >
                <td
                  class="choosen-order__aeroexpress-info__schedule-table__item"
                >
                  {{ time.dep_time }}
                </td>
                <td
                  class="choosen-order__aeroexpress-info__schedule-table__item"
                >
                  {{ time.arr_time }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- <div v-else-if="appropriateFromSchedule(this.schedule, this.schedule.showArrAeroexpress, this.schedule.showDepAeroexpress, this.schedule.reverseAeroexpress, this.routeDate)">
        <p
          v-html="`${this.schedule.aeroexpressFromTitle}`"
          class="choosen-order__aeroexpress-info__title"
        ></p>

        <div class="choosen-order__aeroexpress-info__schedule-wrapper">
          <div
            class="choosen-order__aeroexpress-info__schedule-titles__wrapper"
          >
            <table class="choosen-order__aeroexpress-info__schedule-table">
              <thead>
                <tr>
                  <th>
                    <div
                      class="
                        choosen-order__aeroexpress-info__schedule-titles__title-wrapper
                      "
                    >
                      <p
                        class="
                          choosen-order__aeroexpress-info__schedule-titles__title
                        "
                      >
                        {{ this.schedule.aeroexpressFromDepName }}
                      </p>
                      <p
                        class="
                          choosen-order__aeroexpress-info__schedule-titles__info
                        "
                      >
                        Отправление
                      </p>
                    </div>
                  </th>
                  <th>
                    <div
                      class="
                        choosen-order__aeroexpress-info__schedule-titles__title-wrapper
                      "
                    >
                      <p
                        class="
                          choosen-order__aeroexpress-info__schedule-titles__title
                        "
                      >
                        {{ this.schedule.aeroexpressFromArrName }}
                      </p>
                      <p
                        class="
                          choosen-order__aeroexpress-info__schedule-titles__info
                        "
                      >
                        Прибытие
                      </p>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(time, index) in this.schedule
                    .aeroexpressScheduleFromMorning"
                  :key="index"
                >
                  <td
                    class="
                      choosen-order__aeroexpress-info__schedule-table__item
                    "
                    :class="time.Class + 'tbl'"
                  >
                    {{ time.DepartureTime }}
                  </td>
                  <td
                    class="
                      choosen-order__aeroexpress-info__schedule-table__item
                    "
                    :class="time.Class + 'tbl'"
                  >
                    {{ time.ArrivalTime }}
                  </td>
                </tr>
                <tr
                  v-for="(time, index) in this.schedule
                    .aeroexpressScheduleFromDay"
                  :key="index"
                >
                  <td
                    class="
                      choosen-order__aeroexpress-info__schedule-table__item
                    "
                    :class="time.Class + 'tbl'"
                  >
                    {{ time.DepartureTime }}
                  </td>
                  <td
                    class="
                      choosen-order__aeroexpress-info__schedule-table__item
                    "
                    :class="time.Class + 'tbl'"
                  >
                    {{ time.ArrivalTime }}
                  </td>
                </tr>
                <tr
                  v-for="(time, index) in this.schedule
                    .aeroexpressScheduleFromEvening"
                  :key="index"
                >
                  <td
                    class="
                      choosen-order__aeroexpress-info__schedule-table__item
                    "
                    :class="time.Class + 'tbl'"
                  >
                    {{ time.DepartureTime }}
                  </td>
                  <td
                    class="
                      choosen-order__aeroexpress-info__schedule-table__item
                    "
                    :class="time.Class + 'tbl'"
                  >
                    {{ time.ArrivalTime }}
                  </td>
                </tr>
                <tr
                  v-for="(time, index) in this.schedule
                    .aeroexpressScheduleFromNight"
                  :key="index"
                >
                  <td
                    class="
                      choosen-order__aeroexpress-info__schedule-table__item
                    "
                    :class="time.Class + 'tbl'"
                  >
                    {{ time.DepartureTime }}
                  </td>
                  <td
                    class="
                      choosen-order__aeroexpress-info__schedule-table__item
                    "
                    :class="time.Class + 'tbl'"
                  >
                    {{ time.ArrivalTime }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref } from "vue";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "OrderPassengersCard",
  components: {
    Button,
    Skeleton,
  },
  props: ["order", "codeDepRus", "codeArrRus", "time"],
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const routeDate = ref(null);
    // const codeDepRus = ref(null);
    // const codeArrRus = ref(null);
    const nameDep = ref("");
    const nameArr = ref("");
    const schedule = ref(null);
    const newSchedule = ref(null);
    const router = useRouter();
    const route = useRoute();
    // const getSchedule = async () => {
    //   isLoading.value = true;
    //   try {
    //     const json = await axioCred.get(
    //       `https://www.biletdv.ru/customer/IBEServices/GetAeroexpressSchedule?guid=${props.order}`
    //     );
    //     let fetchedPass = await json.data;
    //     schedule.value = fetchedPass;
    //     console.log(schedule.value);
    //     isLoading.value = false;
    //   } catch (err) {
    //     error.value = err;
    //     console.log(error.value);
    //   }
    // };
    const getNewSchedule = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/AeroexpressGetSchedule?departure=${props.codeDepRus}&arrival=${props.codeArrRus}&date=${props.time}`
        );
        let fetchedPass = await json.data;
        newSchedule.value = fetchedPass;
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      isLoading,
      error,
      schedule,
      routeDate,
      getNewSchedule,
      newSchedule,
      // codeDepRus,
      // codeArrRus,
      nameDep,
      nameArr,
    };
  },
  data() {
    return {};
  },
  computed: {
    getDepName(): any {
      return this.$route.params.nameDep;
    },
    getArrName(): any {
      return this.$route.params.nameArr;
    },
  },
  methods: {
    getDate(date: any) {
      let month = [
        "Января",
        "Февраля",
        "Марта",
        "Апреля",
        "Мая",
        "Июня",
        "Июля",
        "Августа",
        "Сентября",
        "Октября",
        "Ноября",
        "Декабря",
      ];

      let monthNum = new Date(date);
      return (
        monthNum.getDate() +
        " " +
        month[monthNum.getMonth()] +
        " " +
        monthNum.getFullYear()
      );
    },
    pushBack() {
      this.$router.back();
    },
    getDotDate(date: any) {
      let dotDate;
      let fullDate = new Date(date);
      let day = fullDate.getDate();
      let month = fullDate.getMonth();
      let fullMonth;
      let year = fullDate.getFullYear();
      if (month < 10) {
        fullMonth = "0" + month;
      } else {
        fullMonth = month;
      }
      dotDate = day + "." + fullMonth + "." + year;
      return dotDate;
    },
    apropDay(routeDay: string, aeroTime: string) {
      let toCompareDate1 = new Date(routeDay);
      let toCompareDate2 = new Date(aeroTime);
      if (
        toCompareDate1.getUTCFullYear() == toCompareDate2.getUTCFullYear() &&
        toCompareDate1.getUTCMonth() == toCompareDate2.getUTCMonth() &&
        toCompareDate1.getUTCDate() == toCompareDate2.getDate()
      ) {
        return true;
      } else {
        return false;
      }
      // return compone + " " + comptwo
    },
    // checkCodeDep() {
    //   if (this.getCodeDepRus) {
    //     this.codeDepRus = this.getCodeDepRus;
    //   } else {
    //     return
    //   }
    // },
    // checkCodeArr() {
    //   if (this.getCodeArrRus) {
    //     this.codeArrRus = this.getCodeArrRus;
    //   } else {
    //     return
    //   }
    // },
    checkNameDep() {
      if (this.getDepName) {
        this.nameDep = this.getDepName;
      } else {
        if (this.codeDepRus == "ДМД") {
          this.nameDep = "Домодедово";
        } else if (this.codeDepRus == "ШРМ") {
          this.nameDep = "Шереметьево";
        } else if (this.codeDepRus == "ВНК") {
          this.nameDep = "Внуково";
        } else if (this.codeDepRus == "ПВК") {
          this.nameDep = "Павелецкий вокзал";
        } else if (this.codeDepRus == "БСЖ") {
          this.nameDep = "Белорусский вокзал";
        } else if (this.codeDepRus == "КВЖ") {
          this.nameDep = "Киевский вокзал";
        } else {
          return;
        }
      }
    },
    checkNameArr() {
      if (this.getArrName) {
        this.nameArr = this.getArrName;
      }
      {
        if (this.codeArrRus == "ДМД") {
          this.nameArr = "Домодедово";
        } else if (this.codeArrRus == "ШРМ") {
          this.nameArr = "Шереметьево";
        } else if (this.codeArrRus == "ВНК") {
          this.nameArr = "Внуково";
        } else if (this.codeArrRus == "ПВК") {
          this.nameArr = "Павелецкий вокзал";
        } else if (this.codeArrRus == "БСЖ") {
          this.nameArr = "Белорусский вокзал";
        } else if (this.codeArrRus == "КВЖ") {
          this.nameArr = "Киевский вокзал";
        } else {
          return;
        }
      }
    },
  },

  created() {
    this.checkNameDep();
    this.checkNameArr();
    this.getNewSchedule();
  },
});
</script>

<style>
.aeroexpress-schedule_skeleton-wrapper {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}

.aeroexpress-schedule__skeleton {
  margin: auto;
  margin-top: 5px;
}

.choosen-order__aeroexpress-info__title {
  font-size: 22px;
  text-align: center;
  margin-bottom: 10px;
}

.choosen-order__aeroexpress-info__schedule-wrapper {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
}

.choosen-order__aeroexpress-info__schedule-table th,
.choosen-order__aeroexpress-info__schedule-table td {
  border-bottom: 1px solid #ebeced;
  vertical-align: middle;
}

.choosen-order__aeroexpress-info__schedule-titles__wrapper {
  display: flex;
  text-align: center;
  justify-content: center;
}

.choosen-order__aeroexpress-info__schedule-titles__title-wrapper {
  text-align: center;
  padding: 15px 10px 10px 15px;
}

.choosen-order__aeroexpress-info__schedule-titles__title {
  font-size: 18px;
}

.choosen-order__aeroexpress-info__schedule-titles__info {
  font-size: 16px;
  color: #939090;
}

.preferablytbl {
  font-weight: bold;
}

.choosen-order__aeroexpress-info__schedule-table__item {
  height: 35px;
}
</style>
